import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronLeft } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NavContainer } from './nav-container';
export const NavBack = ({ onClick }) => {
    const navigate = useNavigate();
    return (_jsx(NavContainer, { children: _jsx(Button, { startIcon: _jsx(ChevronLeft, {}), onClick: onClick ?? (() => navigate(-1)), children: "Back" }) }));
};
